import React from 'react';
import PropTypes from 'prop-types';

const CourseCard = ({
  id,
  image,
  price,
  name,
  description,
  details,
  kitLink,
}) => {
  return (
    <div
      id={id}
      className="course-card"
      style={{
        display: 'flex',
        height: '500px',
        width: '1080px',
        overflow: 'hidden',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
      }}
    >
      {/* Left: Image */}
      <div
        style={{
          width: '50%',
          overflow: 'hidden',
        }}
      >
        <img
          src={image}
          alt={name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Right: Content */}
      <div
        style={{
          width: '50%',
          padding: '1rem',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <p
          style={{
            fontWeight: 'bold',
            marginBottom: '0.5rem',
          }}
        >
          ${price}
        </p>

        <h1 className="title is-11"
          style={{
            fontSize: '1.1rem',
            marginBottom: '0.75rem',
            
          }}
        >
          {name}
        </h1>

        <p
          style={{
            flexGrow: 1,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {description}
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <a
            href={details}
            className="button is-link"
          >
            Details
          </a>

          <a
            href={kitLink}
            className="button is-dark"
          >
            Get it now!
          </a>
        </div>
      </div>
    </div>
  );
};

CourseCard.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  description: PropTypes.string,
  details: PropTypes.string,
  kitLink: PropTypes.string,
};

export default CourseCard;